export default __webpack_public_path__ + "static/media/client-2.0e9a56a0.webp";